<template>
  <modal
    :visible.sync="visibleSync"
  >
    <div class="advice content">
      <img v-if="modalImage"
           class="dialog__img"
           :src="modalImage"
      />
      <font-awesome-icon
        v-else-if="modalIcon"
        :icon="modalIcon"
        class="dialog__img"/>
      <font-awesome-icon
        v-else
        :icon="['fal', 'lightbulb-on']"
        class="dialog__img" />
      <div class="dialog__info">
        <h1 class="dialog__info__title">{{ modalTitle }}</h1>
        <div class="dialog__info__section"
             v-html="modalContent">
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from '../../utils/Modal.vue';

export default {
  name: 'AdviceModal',
  components: { Modal },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    advice: {
      type: Object,
      default: null,
    },
  },
  computed: {
    visibleSync: {
      get() {
        return this.visible;
      },
      set(value) {
        this.$emit('update:visible', value);
      },
    },
    modalIcon() {
      if (!this.advice) {
        return null;
      }
      return this.advice.modalContent.icon ?? this.advice.content.icon;
    },
    modalImage() {
      if (!this.advice) {
        return null;
      }
      return this.advice.modalContent.image ?? this.advice.content.image;
    },
    modalTitle() {
      if (!this.advice) {
        return '';
      }
      return this.$t(this.advice.modalContent.title ?? this.advice.content.title);
    },
    modalContent() {
      if (!this.advice) {
        return '';
      }
      return this.$t(this.advice.modalContent.summary ?? this.advice.content.summary);
    },
  },
};
</script>

<style scoped lang="scss">
  .content {
    display: grid;
  }
  .dialog {
    &__img {
      justify-self: center;
      width: 42px;
      height: 42px;
    }
    &__info {
      &__title {
        font-size: 22px;
        font-weight: bold;
        text-align: center;
        line-height: 22px;
        color: $--color-text-primary;
        place-self: center;
      }
      &__section{
        display: block;
        margin: 20px 0;
        font-size: $--font-size-medium;
        @include breakpoint(mobile) {
          font-size: $--font-size-large;
        }
      }
    }
  }
</style>
